import { Stack, Typography, Box, Button } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import { ClientInputField } from '../../common/ClientInputField';
import { medicalConditionsData } from '../../../../data/medicalConditionsData';
import { useState } from 'react';
import ClientButton from '../../common/Clientbutton';

export default function MedicalCondition({ userData, setUserData, onNext }) {
    const { theme } = useClient();
    const [inputValue, setInputValue] = useState('');
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [formError, setFormError] = useState("");

    // dynamically Remove item from userdata fields with array option 
    const onCloseIconClickInOptionArrayList = (itemToRemove, field) => {
        setUserData((prevState) => {
            const updatedField = prevState[field].filter((item) => item !== itemToRemove);
            return {
                ...prevState,
                [field]: updatedField,
            };
        });
    };

    const updateListInputsValue = (e, field) => {
        setUserData((prevState) => {
            // Dynamically update the field (using bracket notation to access field dynamically)
            const updatedField = prevState[field] ? [...prevState[field], inputValue.trim()] : [inputValue.trim()];
            return {
                ...prevState,
                [field]: updatedField, // Dynamically set the field value
            };
        });

        // Reset input value after adding to the array
        setInputValue("");

    }

    // Function to handle dynamic field update on "Enter" key press
    const CustomFieldForDetailQuestionKeyPress = (e, field) => {
        // Check if the "Enter" key is pressed and input is not empty
        if (e.key === 'Enter' && inputValue.trim() !== '') {
            updateListInputsValue(e, field)
            clearAllFormError();
        }
    };

    // Handles input change for fields like allergy, medication, and supplement
    const CustomFildForDetailQuestionInputChange = (e, field, relatedsuggestionList) => {
        const newValue = e.target.value;
        setInputValue(newValue);
        let filtered = [];
        // Filter the available options based on the input value (case-insensitive match)
        filtered = relatedsuggestionList.filter(option =>
            option.toLowerCase().includes(newValue.toLowerCase())  // Filter options by containing match
        );

        //      filtered = relatedsuggestionList.filter(option =>
        //         option.toLowerCase().startsWith(newValue.toLowerCase())  // Filter options by starting match
        //     );

        // Update the filtered options state
        setFilteredOptions(filtered);

        // Clear form errors as the user starts typing
        clearAllFormError();
    };

    // Handles selection of a suggested option for a specific field
    const handleSuggestedOptionSelect = (field, option, availableOptions) => {
        console.log("Selected Field:", field, "Selected Option:", option);

        // Ensure that the field exists and is an array
        const currentFieldData = Array.isArray(userData[field]) ? userData[field] : [];

        // Check if the option is already added to avoid duplicates
        if (!currentFieldData.includes(option)) {
            setUserData(prev => ({
                ...prev,
                [field]: Array.isArray(prev[field]) ? [...prev[field], option] : [option] // Ensure prev[field] is an array
            }));
        }

        // Clear the input field after selection
        setInputValue('');

        // Reset filtered options based on the selected field
        setFilteredOptions(availableOptions);  // Reset only the options for the selected field
    };


    //this fn will handle add btn click logic for add allergy,medication to list
    const onAddBtnClick = (e, field) => {
        if (inputValue.trim() !== '') {
            updateListInputsValue(e, field)
            clearAllFormError();
        }

    }

    const clearAllFormError = () => {
        setFormError("")
    }

    const handleNextStep = (field) => {
        let isValid = true;
        console.log(userData);

        if (!userData[field]?.length) {
            setFormError("Please add details");
            isValid = false;
        }
        if (isValid) {
            onNext()
        }
    };

    const handleSkip = (field) => {
        setFormError(null);
        setUserData((prevState) => ({
            ...prevState,
            [field]: [], // Set the specific field to an empty array
        }));
        onNext()
    }

    return (
        <Stack
            spacing={2}
            sx={{
                width: '100%',
                maxWidth: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
        >
            <ClientInputField
                title="Do you have any medical conditions?"
                extraText=""
                // btnTitle="Next"
                skipBtnTitle="No, skip"
                onClickNext={() => handleNextStep("medicalCondition")}
                onClickSkip={() => handleSkip("medicalCondition")}
                // Input props
                placeholder="Enter medical condition name"
                minRowsCount={1}
                value={inputValue}
                onChange={(e) =>
                    CustomFildForDetailQuestionInputChange(e, "medicalCondition", medicalConditionsData)
                }
                onKeyDown={(e) => CustomFieldForDetailQuestionKeyPress(e, "medicalCondition")}
                isAddButtonInUI={true}
                onAddBtnClick={(e) => onAddBtnClick(e, "medicalCondition")}

                // Suggestions
                inputValue={inputValue}
                filteredOptions={filteredOptions}
                handleSuggestedOptionSelect={(field, options) =>
                    handleSuggestedOptionSelect(field, options, medicalConditionsData)
                }

                // Selected list
                answerArray={userData.medicalCondition}
                onCloseIconClickInOptionArrayList={onCloseIconClickInOptionArrayList}

                // Field error
                field="medicalCondition"
                isFieldError={formError}

            // Optional brand colors (customize per brand if needed)
            // brandColors={{
            //     hoverBackground: '#f0f0f0',
            //     suggestionTextColor: '#333',
            //     chipBackground: '#e0f7fa',
            //     chipTextColor: '#00796b',
            //     removeIconColor: '#d32f2f',
            //     hoverText: '#fff',
            //     hoverBgColor: '#00796b',
            //     addButtonColor: '#00796b',
            // }}
            />




        </Stack>
    );
}